/* eslint-disable react/no-array-index-key */
import React, { Component } from "react";

import cx from "classnames";
import PropTypes from "prop-types";

import BackgroundWrapper from "./BackgroundWrapper";

export default class TimeSlotGroup extends Component {
	render() {
		const {
			renderSlot,
			resource,
			group,
			getters,
			components: { timeSlotWrapper: Wrapper = BackgroundWrapper } = {},
		} = this.props;

		const groupProps = getters ? getters.slotGroupProp(group) : {};
		return (
			<div className="fbc-timeslot-group" {...groupProps}>
				{group.map((value, idx) => {
					const slotProps = getters ? getters.slotProp(value, resource) : {};
					return (
						<Wrapper key={idx} value={value} resource={resource}>
							<div {...slotProps} className={cx("fbc-time-slot", slotProps.className)}>
								{renderSlot && renderSlot(value, idx)}
							</div>
						</Wrapper>
					);
				})}
			</div>
		);
	}
}

TimeSlotGroup.propTypes = {
	renderSlot: PropTypes.func,
	group: PropTypes.array.isRequired,
	resource: PropTypes.any,
	components: PropTypes.object,
	getters: PropTypes.object,
};
